export default function Enemy() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="enemy" className="py-32 bg-gradient-to-br from-white via-[#F6F9FB] to-white relative overflow-hidden">
      {/* Premium Background Elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-br from-[#C8D8E4]/30 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-[#F6D7DF]/20 to-transparent rounded-full blur-3xl"></div>
      
      <div className="max-w-[1400px] mx-auto px-6 relative z-10">

        {/* One-line trust bullet — Licensed pro verifies measurements */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-white border border-[#52AB98]/30 rounded-full shadow-sm">
            <i className="ri-ruler-2-line text-[#52AB98] text-base"></i>
            <span className="text-sm font-semibold text-[#2B6777]">
              Licensed pro verifies measurements before your windows are ordered
            </span>
          </div>
        </div>

        {/* F-Pattern: Top Horizontal Bar */}
        <div className="text-center mb-20">
          {/* Label Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#F6D7DF]/40 to-[#FFE5EC]/40 backdrop-blur-sm rounded-full mb-6 border border-[#D98CA3]/20 shadow-sm">
            <div className="w-2 h-2 bg-[#D98CA3] rounded-full animate-pulse"></div>
            <span className="text-sm font-bold text-[#2B6777] uppercase tracking-wider">
              No Pressure. By Design.
            </span>
          </div>

          {/* Main Headline */}
          <h2 className="text-5xl md:text-6xl font-heading font-bold text-[#2B6777] mb-6 tracking-tight leading-[1.1]">
            Why buy windows online with<br />
            <span className="text-[#52AB98]">SNAPwindows.ai?</span>
          </h2>
        </div>

        {/* F-Pattern: Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Left: Premium Image with Overlay */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#52AB98]/20 to-[#2B6777]/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7dd787017d3175217eb2185ff0fd2886.jpg"
                alt="Modern home with new windows"
                className="w-full h-[600px] object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              
              {/* Floating Trust Badge on Image */}
              <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-md rounded-2xl p-6 shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#52AB98] to-[#478F82] rounded-full flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <p className="text-lg font-bold text-[#2B6777] mb-1">NO MONEY DOWN</p>
                    <p className="text-sm text-[#2B6777]/70">Pay only after <strong>100% SATISFIED</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Story Content */}
          <div className="space-y-8">
            {/* Main Story */}
            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-10 shadow-lg border border-[#2B6777]/10">
              <p className="text-xl text-[#2B6777] leading-relaxed mb-6">
                For too long, buying windows has revolved around sales appointments — not customer satisfaction. SNAPwindows.ai was built to set a higher standard, giving homeowners a clear, more modern way to improve their home's beauty, increase energy efficiency, and build long-term value, all with a process that puts you firmly in control.
              </p>
              <p className="text-xl text-[#2B6777] leading-relaxed font-medium">
                There are no in-home sales visits. No pressure-driven decisions. And <strong>NO MONEY DOWN</strong> until your project is 100% complete.
              </p>
            </div>

            {/* Subheadline */}
            <div className="text-center lg:text-left">
              <h3 className="text-3xl font-heading font-bold text-[#2B6777] mb-2">
                Why Homeowners Choose SNAPwindows.ai
              </h3>
              <div className="w-24 h-1 bg-gradient-to-r from-[#52AB98] to-[#D98CA3] rounded-full mx-auto lg:mx-0"></div>
            </div>
          </div>
        </div>

        {/* F-Pattern: Premium Visual Benefits Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1200px] mx-auto">
          {/* Benefit 1 - Premium Photo Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-[#2B6777]/5 hover:border-[#52AB98]/30 hover:-translate-y-1">
            <div className="h-40 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20handshake%20between%20homeowner%20and%20contractor%20in%20front%20of%20beautiful%20new%20windows%20trust%20and%20satisfaction%20moment%20warm%20natural%20lighting%20residential%20home%20setting%20premium%20quality%20photography&width=400&height=200&seq=benefit-trust-v1&orientation=landscape"
                alt="Trust and satisfaction"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent"></div>
            </div>
            <div className="p-6 pt-2 relative">
              <p className="text-lg font-semibold text-[#2B6777] leading-relaxed">
                <strong>NO MONEY DOWN</strong> until your project is 100% Complete
              </p>
            </div>
          </div>

          {/* Benefit 2 - Premium Photo Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-[#2B6777]/5 hover:border-[#52AB98]/30 hover:-translate-y-1">
            <div className="h-40 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20energy%20efficient%20window%20close%20up%20showing%20quality%20craftsmanship%20warranty%20protection%20concept%20lifetime%20durability%20premium%20residential%20window%20installation%20soft%20natural%20lighting&width=400&height=200&seq=benefit-warranty-v1&orientation=landscape"
                alt="Lifetime warranty"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent"></div>
            </div>
            <div className="p-6 pt-2 relative">
              <p className="text-lg font-semibold text-[#2B6777] leading-relaxed">
                Lifetime of the Home Warranty backed by Alside. Including Glass Breakage Warranty
              </p>
            </div>
          </div>

          {/* Benefit 3 - Premium Photo Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-[#2B6777]/5 hover:border-[#52AB98]/30 hover:-translate-y-1">
            <div className="h-40 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20window%20installer%20using%20precision%20measuring%20tape%20on%20window%20frame%20accurate%20measurements%20custom%20fit%20residential%20home%20renovation%20quality%20craftsmanship%20natural%20lighting&width=400&height=200&seq=benefit-measure-v1&orientation=landscape"
                alt="Professional measurements"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent"></div>
            </div>
            <div className="p-6 pt-2 relative">
              <p className="text-lg font-semibold text-[#2B6777] leading-relaxed">
                A licensed professional verifies all measurements before your custom windows are ordered
              </p>
            </div>
          </div>

          {/* Benefit 4 - Premium Photo Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-[#2B6777]/5 hover:border-[#52AB98]/30 hover:-translate-y-1">
            <div className="h-40 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Team%20of%20professional%20window%20installers%20in%20branded%20uniforms%20working%20together%20on%20residential%20project%20factory%20trained%20experts%20licensed%20insured%20crew%20safety%20equipment%20clean%20worksite&width=400&height=200&seq=benefit-team-v1&orientation=landscape"
                alt="Professional installation team"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent"></div>
            </div>
            <div className="p-6 pt-2 relative">
              <p className="text-lg font-semibold text-[#2B6777] leading-relaxed">
                Your windows are installed by a factory trained, licensed and insured installation crew
              </p>
            </div>
          </div>

          {/* Benefit 5 - Premium Photo Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-[#2B6777]/5 hover:border-[#52AB98]/30 hover:-translate-y-1">
            <div className="h-40 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Homeowner%20using%20smartphone%20to%20photograph%20windows%20for%20online%20proposal%20easy%20digital%20process%20modern%20technology%20convenience%20home%20exterior%20natural%20daylight%20casual%20lifestyle&width=400&height=200&seq=benefit-phone-v1&orientation=landscape"
                alt="Easy phone process"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/50 to-transparent"></div>
            </div>
            <div className="p-6 pt-2 relative">
              <p className="text-lg font-semibold text-[#2B6777] leading-relaxed">
                Get your proposal in minutes — right from your phone, no appointment needed
              </p>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <a
            href="https://api.leadconnectorhq.com/widget/form/0ZsIY0jYLaF8aXm2FeXI"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-12 py-5 bg-[#52AB98] text-white text-lg font-bold rounded-xl hover:bg-[#478F82] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-105 transform duration-300"
          >
            Start With Photos
            <i className="ri-camera-line text-xl"></i>
          </a>
          <p className="text-sm text-[#2B6777]/60 mt-4 font-medium">
            Takes ~2 minutes · No credit card · No in-home sales visit
          </p>
        </div>
      </div>
    </section>
  );
}
